// client/src/routes/app/expenses/index.tsx — SCR-EXP-001 · EXP-005 (04 §8.7).
//
// Replaces UI-003's `PlaceholderScreen`, which was here so that its „all V1 module routes exist
// in the sidebar, may point to placeholder pages" criterion would be literally true, and which
// named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and the
// screen reads it back typed.
//
// `Expenses.Read`, which is what UI-003 already gated the placeholder on and what 03 §17.1
// grants the accountant. The write controls inside the screen require `Expenses.Write`, which
// the accountant does not hold — the same read/write split BANK-004 had to make for Banking
// (D-725).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ExpenseLedgerScreen } from '@/features/expenses/ExpenseLedger';
import { expenseSearchSchema, type ExpenseSearch } from '@/features/expenses/search';

export const Route = createFileRoute('/app/expenses/')({
  validateSearch: expenseSearchSchema,
  component: ExpensesScreen,
});

function ExpensesScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Expenses.Read">
      <ExpenseLedgerScreen
        search={search}
        onSearchChange={(next: (previous: ExpenseSearch) => ExpenseSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
